import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  operations as reportsOperations,
  selectors as reportsSelectors,
} from 'store/reportsManager'
import AdminK8Tier2View from './component'
import AdminK8Tier2MultiSiteView from 'components/AdminK8Tier2MultiSiteView'

// NOTE: this is a TEMPORARY component to test the Tier 2 dashboard data
// feel free to replace this or update it as you see fit
export const AdminK8Tier2ViewContainer = ({
  adminEmail,
  fetchTier2DashboardData,
  isFetchingTier2Dashboard,
  selectedProgram,
  shouldFetchTier2Dashboard,
  tier2DashboardSites,
}) => {
  // Determine if we should show multi-site or single-site view
  const isMultiSite =
    tier2DashboardSites &&
    Array.isArray(tier2DashboardSites) &&
    tier2DashboardSites.length > 1

  useEffect(() => {
    if (shouldFetchTier2Dashboard && selectedProgram?.key) {
      fetchTier2DashboardData({
        adminEmail,
        program: selectedProgram.key,
      })
    }
  }, [
    shouldFetchTier2Dashboard,
    selectedProgram,
    adminEmail,
    fetchTier2DashboardData,
  ])

  return (
    <>
      {isMultiSite ? (
        <AdminK8Tier2MultiSiteView tier2DashboardSites={tier2DashboardSites} />
      ) : (
        <AdminK8Tier2View
          isFetching={isFetchingTier2Dashboard}
          tier2DashboardSites={tier2DashboardSites}
        />
      )}
    </>
  )
}

const mapStateToProps = state => {
  const {
    reportsManager: {
      selectedProgram,
      admin: {
        k8: {
          tier2: {
            dashboard: { isFetching: isFetchingTier2Dashboard },
          },
        },
      },
    },
    userProfileManager: {
      profile: { email: adminEmail },
    },
  } = state

  // Get tier2 dashboard sites (read-only, fetching happens in useEffect)
  const tier2DashboardSites = reportsSelectors.selectTier2DashboardSites(state)
  // Use createSelectorState output to determine if we should fetch:
  // - null = not hydrated, should fetch
  // - {} = fetching/error, don't fetch (createSelectorState handles this)
  // - array = hydrated, don't fetch
  const shouldFetchTier2Dashboard = tier2DashboardSites === null

  return {
    adminEmail,
    isFetchingTier2Dashboard,
    selectedProgram,
    shouldFetchTier2Dashboard,
    tier2DashboardSites,
  }
}

const mapDispatchToProps = {
  fetchTier2DashboardData: reportsOperations.fetchTier2DashboardData,
}

AdminK8Tier2ViewContainer.propTypes = {
  adminEmail: PropTypes.string,
  fetchTier2DashboardData: PropTypes.func,
  isFetchingTier2Dashboard: PropTypes.bool,
  selectedProgram: PropTypes.object,
  shouldFetchTier2Dashboard: PropTypes.bool,
  tier2DashboardSites: PropTypes.array,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminK8Tier2ViewContainer)
